import React from "react";
import "./Black_Btn.css";
import { Button } from "react-bootstrap";

function Black_Btn({onClick, btnText,type }) {
  return (
    <section className="Black_Btn_holder">
      <Button className="Black_Btn" type={type || 'button'} onClick={onClick}>{btnText}</Button>
    </section>
  );
}

export default Black_Btn;
